(function(angular) {
    "use strict";
    var feed, channelFeed;

    class FeedModel {
        constructor($rootScope, $log) {
            this.$rootScope = $rootScope;
            this.$log = $log;
            this.MAX_ITEMS = 500;
            feed = [];
            channelFeed = new Map();

            $rootScope.$on('ConnectionService.logout', () => {
                this.clearFeed();
            });
        }

        getChannelFeed(channelId) {
            if (!channelFeed.has(channelId)) {
                channelFeed.set(channelId, []);
            }

            return channelFeed.get(channelId);
        }

        addChannelFeedEvent(channelId, name, type, data) {
            var channelFeedEvent = {
                "feedId": 0,
                "channelId": channelId,
                "type": type,
                "data": data,
                "name": name,
                "confirmed": false,
                "clientTime": new Date()
            }

            if (type !== "end-speaking") { // don't add the end-speaking events
                let feedId = feed.push(channelFeedEvent); //channelModel.getChannel(channelId).events.push(channelFeedEvent);
                let channelFeed = this.getChannelFeed(channelId);
                channelFeed.push(channelFeedEvent);

                if (channelFeed.length > this.MAX_ITEMS) {
                    channelFeed.shift();
                }

                channelFeedEvent.feedId = feedId;
            }

            //this.$log.debug("addChannelFeedEvent: ", channelFeedEvent);
            this.$rootScope.$broadcast("feedModel.feedEventReceived", channelFeedEvent);
            return channelFeedEvent;
        }
        clearFeed() {
            feed = [];
            channelFeed.clear();
        }
    }

    angular
        .module('webcomm')
        .service('feedModel', ['$rootScope', '$log', FeedModel]);
})(angular);